import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

export const getSubscribers = async () => {
  const response = await api.get('/newsletter/subscribers');
  return response.data;
};

export const updateSubscriptionStatus = async ({ id, email, status }) => {
  const response = await api.patch(`/newsletter/subscribers/${id}`, {
    email,
    status
  });
  return response.data;
};